import type { ResponseMode } from './shared-survey-project-response-mode.types';

export function shouldResetRecordingBufferOnModeChange(
  nextMode: ResponseMode,
  locked: boolean
): boolean {
  return nextMode === 'text' && !locked;
}

// Helper function to create WAV header
export function createWavHeader(
  dataLength: number,
  sampleRate: number,
  channels: number,
  bitsPerSample: number
): ArrayBuffer {
  const buffer = new ArrayBuffer(44);
  const view = new DataView(buffer);

  // RIFF identifier
  view.setUint32(0, 0x52494646, false); // "RIFF"

  // File size (data length + header size - 8)
  view.setUint32(4, 36 + dataLength * 2, true);

  // WAVE identifier
  view.setUint32(8, 0x57415645, false); // "WAVE"

  // fmt chunk
  view.setUint32(12, 0x666d7420, false); // "fmt "
  view.setUint32(16, 16, true); // fmt chunk size
  view.setUint16(20, 1, true); // Audio format (PCM)
  view.setUint16(22, channels, true); // Number of channels
  view.setUint32(24, sampleRate, true); // Sample rate
  view.setUint32(28, (sampleRate * channels * bitsPerSample) / 8, true); // Byte rate
  view.setUint16(32, (channels * bitsPerSample) / 8, true); // Block align
  view.setUint16(34, bitsPerSample, true); // Bits per sample

  // data chunk
  view.setUint32(36, 0x64617461, false); // "data"
  view.setUint32(40, dataLength * 2, true); // Data size

  return buffer;
}
